export * from './classes';
export * from './color-picker.directive';
export * from './color-picker.module';
export * from './color-picker.service';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./~/angular2-color-picker/lib/index.ts